import React from "react";
import { isEqual } from "lodash";

import withFollowedStocksMap from "../../../../../hocs/withFollowedStocksMap";
import withUserData from "../../../../../hocs/withUserData";
import withMarketTransltaions from "../../../../../hocs/withMarketTranslations";
import { StockPageProvider, withStockPage } from "../../../../../lib/StockPage";
import { getDefaultMarketId } from "../../../../../lib/getDefaultMarketId";
import Loader from "../../../common/Loader";
import PageTitle from "../../../common/PageTitle";
import TvChartBridge from "../../../common/TvChartBridge";

@withUserData
@withStockPage
@withFollowedStocksMap
@withMarketTransltaions
class FullScreenChartInner extends React.Component {
  state = {
    tvChartLoading: false,
    viewportHeight: typeof window !== "undefined" ? window.innerHeight : 800
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ viewportHeight: window.innerHeight });
  };

  render() {
    const {
      stock: stockSlot,
      translate,
      match,
      followedStocksMap,
      marketTranslations
    } = this.props;

    const stock = stockSlot?.data;
    const stockLoading = Boolean(stockSlot?.loading);
    const stockTicker = stock?.stock?.ticker?.toLowerCase?.();
    const stockMarket = stock?.stock?.market?.toLowerCase?.();
    const matchMarket = match?.params?.marketId?.toLowerCase?.();
    const matchTicker = match?.params?.stockId?.toLowerCase?.();
    const userStock = followedStocksMap?.[stock?.stock?.id];

    const canShowTvChart =
      !stockLoading &&
      !this.state.tvChartLoading &&
      stock &&
      stockTicker === matchTicker &&
      stockMarket ===
        getDefaultMarketId(marketTranslations, matchMarket).toLowerCase();

    const handleLoadingStarted = () => {
      this.setState({ tvChartLoading: true });
    };
    const handleLoadingEnded = () => {
      this.setState({ tvChartLoading: false });
    };

    return (
      <div className="fullscreen-chart-page">
        {canShowTvChart ? (
          <React.Fragment>
            <PageTitle title={stock.stock.name} />
            <TvChartBridge
              onRefreshStarted={handleLoadingStarted}
              onRefreshEnded={handleLoadingEnded}
              key={stock.stock.id}
              stock={stock.stock}
              userStock={userStock}
              latestQuoteDatetimeUtc={stock.latest_quote_datetime_utc}
              height={this.state.viewportHeight}
              showStocksListButton
              showFullscreenButton
              isFullscreenView
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <PageTitle
              title={translate("Loading %{ticker}", { ticker: matchTicker })}
            />
            <Loader />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default function FullScreenChart(props) {
  const market = props.match?.params?.marketId || "";
  const ticker = props.match?.params?.stockId || "";

  return (
    <StockPageProvider market={market} ticker={ticker} active>
      <FullScreenChartInner {...props} />
    </StockPageProvider>
  );
}
